import { render } from "./agreement1.vue?vue&type=template&id=1a95932e&scoped=true"
import script from "./agreement1.vue?vue&type=script&lang=js"
export * from "./agreement1.vue?vue&type=script&lang=js"

import "./agreement1.vue?vue&type=style&index=0&id=1a95932e&lang=less&scoped=true"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a95932e"]])

export default __exports__